import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { languageSupport, languageService } from '@app/modules/common/language';

@Component({
    selector: 'ui-modal-cartcount',
    templateUrl:'./ui-count.html',
    styleUrls: [ 
        './ui-count.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiAmountModal extends languageSupport implements OnInit, OnDestroy {
    @ViewChild('input', {static: false}) _input: any;    

    private _amount = null;
    get Amount(){
        return this._amount;
    }

    set Amount(value: string){
        this._amount = (isNaN(parseFloat(value))) ? null : value;
    }
        
    /************************/
    /* STARTS HERE          */
    /************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, private modalCtrl: ModalController, private params: NavParams) {
        super(lang, change);
    }

    ngOnInit() {
        this._amount = null;
    }
    
    ngOnDestroy(){
        super.OnDestroy();
    }

    /************************/
    /* EVENT HANDLERS       */
    /************************/

    get CanAccept(){
        return this.Amount && (Number(this.Amount) > 0) && (Number(this.Amount) < 99);
    }

    async AcceptModal() {
        await this.modalCtrl.dismiss({ amount: Number(this.Amount) });
    }    

    async CloseModal() {
        await this.modalCtrl.dismiss(null);
    }

    OnNumPad(key){
        if (this._input){
            this._input.OnKeyPress(key);
        }
        this.change.markForCheck();
    }
}